import { SECTION } from "feature/feature-helpers";
import { HandlePushNotificationsFeature } from "./handle-push-notifications";
import { ReplyPushNotificationsFeature } from "./reply-push-notifs";
import { PushNotificationPopupFeature } from "./push-notification-popup-settings";

// A feature group for Push notifications, usable for questions and threads
export const PushNotificationFeaturesForThreads = SECTION("Push Notifications", [
    HandlePushNotificationsFeature,
    ReplyPushNotificationsFeature,
    PushNotificationPopupFeature
])